<template>
  <window :id="'meterSetup'" :title="title" ref="windowMeter">
    <div slot="headButton" class="fR cb tra-fast_E ml05x_E">
      <button class="bdSub boxR hover-bg-highLight close">{{$t('cmd85',['取消'])}}</button>
      <button class="functionBtn" @click="save" :class="{disable:((type=='THREE_PHASE'&&spec.ctSpec!=='CT6')&&(!requestData.currentRatioIn||!requestData.currentRatioOut))||((type=='THREE_PHASE'&&spec.ctSpec=='CT6')&&(!requestData.currentRatioIn||!requestData.currentRatioOut||!requestData.currentRatioIn2||!requestData.currentRatioOut2))}" type="button">{{$t('cmd84',['保存'])}}</button>

    </div>
    <div fillHeight="window,-#meterSetup .head,-space,-space" scroll>
      <div class="w80pct mc">
        <p class="fs12x">{{$t('phrase607',['请根据电表的安装情况配置电表互感器属性'])}}</p>
        <div class="mt2x clearfix">
          <div class="bg-meter fL pt1x">
            <svg class="w10x h4x fMain">
              <use xlink:href="#ico-meter"></use>
            </svg>
            <p class="mt1x ml1x">SN{{meter.serialNumber}}</p>
            <ul class="ml1x">
              <li v-if="spec.ctSpec=='CT3'||spec.ctSpec=='CT1'||spec.ctSpec=='CT6'">CT1</li>
              <li v-if="spec.ctSpec=='CT3'||spec.ctSpec=='CT6'">CT2</li>
              <li v-if="spec.ctSpec=='CT3'||spec.ctSpec=='CT6'">CT3</li>
              <li v-if="spec.ctSpec=='CT6'">CT4</li>
              <li v-if="spec.ctSpec=='CT6'">CT5</li>
              <li v-if="spec.ctSpec=='CT6'">CT6</li>
            </ul>
            <!-- <ul class="ml1x" v-else><li>CT1</li></ul> -->
          </div>
          <!-- 三相的可以作为单相使用，也可以作为三相使用,需要用户设置 radio-->
          <div class="fL ml5x mt3x">
            <p v-if="typesRadio.includes('SINGLE_PHASE')">{{$t('word1371',['应用于'])}}</p>
            <p v-if="typesRadio.includes('SINGLE_PHASE')"><label for="single"><input type="radio" id="single" v-model="type" value='SINGLE_PHASE' @click="getSingle">{{getLanguageStr('word1971','单相系统')}}</label></p>
            <p v-if="typesRadio.includes('THREE_PHASE')"><label for="three"><input type="radio" id="three" v-model="type" value='THREE_PHASE' @click="getThree" />{{getLanguageStr('plant_detail164','三相系统')}}</label></p>
          </div>
        </div>
        <!-- 单相系统 -->
        <div v-if="type=='SINGLE_PHASE'">
          <!-- <div class="w15pct fL">{{$t('word1374',['互感器'])}}</div>
					<div class="w15pct fL">{{getLanguageStr('word1972','安装位置')}}</div>
					<div class="w25pct fL">{{getLanguageStr('phrase851','互感器安装方向（点击箭头可切换）')}}</div> -->
          <div class="clearfix mt2x">
            <div class="w15pct fL">{{$t('word1374',['互感器'])}}</div>
            <div class="w15pct fL">{{getLanguageStr('word1972','安装位置')}}</div>
            <div class="w25pct fL">{{getLanguageStr('phrase851','互感器安装方向（点击箭头可切换）')}}</div>
          </div>
          <!-- ct1 -->
          <div class="clearfix mt2x" v-if="spec.ctSpec=='CT1'||spec.ctSpec=='CT3'||spec.ctSpec=='CT6'">
            <div class="w15pct fL h4x line-height">CT1</div>
            <div class="w15pct fL h4x line-height">
              <my-select class="mt1x" v-if="location1Source.length" :list="location1Source" :bindActive="requestData.ct1.purpose" @Click="selectLocation1"></my-select>
            </div>
            <div class="w25pct fL posR">
              <div v-show="requestData.ct1.purpose === 'GENERATION'">
                <!-- 发电  -->
                <svg class="w4x h3x pr05x mr3x">
                  <use xlink:href="#ico-getPower"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5.5em;top:0.5em;" :class="{'active-l':requestData.ct1.direction === 'BACKWARD', 'active-r':requestData.ct1.direction === 'FORWARD'}" @click="changeForward(1)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="60" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
              </div>
              <div v-show="requestData.ct1.purpose === 'CONSUMPTION'">
                <!-- 用电  -->
                <div class='w6x h1x fL'></div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:2em;top:0.5em;" :class="{'active-l':requestData.ct1.direction === 'BACKWARD', 'active-r':requestData.ct1.direction === 'FORWARD'}" @click="changeForward(1)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                <svg class="w4x h4x pr05x ml05x ">
                  <use xlink:href="#ico-house"></use>
                </svg>
              </div>
              <div v-show="requestData.ct1.purpose === 'UTILITY'">
                <!-- 电网  -->
                <div class="fL">
                  <div><span class="s-text">{{$t('plant_detail235',['购电'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line>
                  </div>
                  <div><span class="s-text">{{$t('word162',['并网'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                  </div>
                </div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5em;top:-0.5em;" :class="{'active-l':requestData.ct1.direction === 'BACKWARD', 'active-r':requestData.ct1.direction === 'FORWARD'}" @click="changeForward(1)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <svg class="w4x h3x mt05x fL ">
                  <use xlink:href="#ico-eTower"></use>
                </svg>
              </div>
              <!-- 电池 -->
              <div v-show="requestData.ct1.purpose === 'BATTERY'">
                <svg class="w4x h3x mt05x fL mr2x">
                  <use xlink:href="#ico-battery3"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:7em;top:-0.5em;" :class="{'active-l':requestData.ct1.direction === 'BACKWARD', 'active-r':requestData.ct1.direction === 'FORWARD'}" @click="changeForward(1)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <div class="fL">
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line><span class="s-text ml05x">{{getLanguageStr('word185','充电')}}</span>
                  </div>
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line><span class="s-text ml05x">{{getLanguageStr('word186','放电')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ct2 -->
          <div class="clearfix mt2x" v-if="spec.ctSpec=='CT3'||spec.ctSpec=='CT6'">
            <div class="w15pct fL h4x line-height">CT2</div>
            <div class="w15pct fL h4x line-height">
              <my-select class="mt1x" v-if="location2Source.length" :list="location2Source" :bindActive="requestData.ct2.purpose" @Click="selectLocation2"></my-select>
            </div>
            <div class="w25pct fL posR">
              <div v-show="requestData.ct2.purpose === 'GENERATION'">
                <!-- 发电  -->
                <svg class="w4x h3x pr05x mr3x">
                  <use xlink:href="#ico-getPower"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5.5em;top:0.5em;" :class="{'active-l':requestData.ct2.direction === 'BACKWARD', 'active-r':requestData.ct2.direction === 'FORWARD'}" @click="changeForward(2)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="60" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
              </div>
              <div v-show="requestData.ct2.purpose === 'CONSUMPTION'">
                <!-- 用电  -->
                <div class='w6x h1x fL'></div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:2em;top:0.5em;" :class="{'active-l':requestData.ct2.direction === 'BACKWARD', 'active-r':requestData.ct2.direction === 'FORWARD'}" @click="changeForward(2)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                <svg class="w4x h4x pr05x ml05x">
                  <use xlink:href="#ico-house"></use>
                </svg>
              </div>
              <div v-show="requestData.ct2.purpose === 'UTILITY'">
                <!-- 电网  -->
                <div class="fL">
                  <div><span class="s-text">{{$t('plant_detail235',['购电'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line>
                  </div>
                  <div><span class="s-text">{{$t('word162',['并网'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                  </div>
                </div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5em;top:-0.5em;" :class="{'active-l':requestData.ct2.direction === 'BACKWARD', 'active-r':requestData.ct2.direction === 'FORWARD'}" @click="changeForward(2)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <svg class="w4x h3x mt05x fL">
                  <use xlink:href="#ico-eTower"></use>
                </svg>
              </div>
              <!-- 电池 -->
              <div v-show="requestData.ct2.purpose === 'BATTERY'">
                <svg class="w4x h3x mt05x fL mr2x">
                  <use xlink:href="#ico-battery3"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:7em;top:-0.5em;" :class="{'active-l':requestData.ct2.direction === 'BACKWARD', 'active-r':requestData.ct2.direction === 'FORWARD'}" @click="changeForward(2)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <div class="fL">
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line><span class="s-text ml05x">{{getLanguageStr('word185','充电')}}</span>
                  </div>
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line><span class="s-text ml05x">{{getLanguageStr('word186','放电')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ct3 -->
          <div class="clearfix mt2x" v-if="spec.ctSpec=='CT3'||spec.ctSpec=='CT6'">
            <div class="w15pct fL h4x line-height">CT3</div>
            <div class="w15pct fL h4x line-height">
              <my-select class="mt1x" v-if="location3Source.length" :list="location3Source" :bindActive="requestData.ct3.purpose" @Click="selectLocation3"></my-select>
            </div>
            <div class="w25pct fL posR">
              <div v-show="requestData.ct3.purpose === 'GENERATION'">
                <!-- 发电  -->
                <svg class="w4x h3x pr05x mr3x">
                  <use xlink:href="#ico-getPower"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5.5em;top:0.5em;" :class="{'active-l':requestData.ct3.direction === 'BACKWARD', 'active-r':requestData.ct3.direction === 'FORWARD'}" @click="changeForward(3)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="60" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
              </div>
              <div v-show="requestData.ct3.purpose === 'CONSUMPTION'">
                <!-- 用电  -->
                <div class='w6x h1x fL'></div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:2em;top:0.5em;" :class="{'active-l':requestData.ct3.direction === 'BACKWARD', 'active-r':requestData.ct3.direction === 'FORWARD'}" @click="changeForward(3)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                <svg class="w4x h4x pr05x ml05x">
                  <use xlink:href="#ico-house"></use>
                </svg>
              </div>
              <div v-show="requestData.ct3.purpose === 'UTILITY'">
                <!-- 电网  -->
                <div class="fL">
                  <div><span class="s-text">{{$t('plant_detail235',['购电'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line>
                  </div>
                  <div><span class="s-text">{{$t('word162',['并网'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                  </div>
                </div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5em;top:-0.5em;" :class="{'active-l':requestData.ct3.direction === 'BACKWARD', 'active-r':requestData.ct3.direction === 'FORWARD'}" @click="changeForward(3)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <svg class="w4x h3x mt05x fL ">
                  <use xlink:href="#ico-eTower"></use>
                </svg>
              </div>
              <!-- 电池 -->
              <div v-show="requestData.ct3.purpose === 'BATTERY'">
                <svg class="w4x h3x mt05x fL mr2x">
                  <use xlink:href="#ico-battery3"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:7em;top:-0.5em;" :class="{'active-l':requestData.ct3.direction === 'BACKWARD', 'active-r':requestData.ct3.direction === 'FORWARD'}" @click="changeForward(3)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <div class="fL">
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line><span class="s-text ml05x">{{getLanguageStr('word185','充电')}}</span>
                  </div>
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line><span class="s-text ml05x">{{getLanguageStr('word186','放电')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ct4 -->
          <div class="clearfix mt2x" v-if="spec.ctSpec=='CT6'">
            <div class="w15pct fL h4x line-height">CT4</div>
            <div class="w15pct fL h4x line-height">
              <my-select class="mt1x" v-if="location4Source.length" :list="location4Source" :bindActive="requestData.ct4.purpose" @Click="selectLocation4"></my-select>
            </div>
            <div class="w25pct fL posR">
              <div v-show="requestData.ct4.purpose === 'GENERATION'">
                <!-- 发电  -->
                <svg class="w4x h3x pr05x mr3x">
                  <use xlink:href="#ico-getPower"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5.5em;top:0.5em;" :class="{'active-l':requestData.ct4.direction === 'BACKWARD', 'active-r':requestData.ct4.direction === 'FORWARD'}" @click="changeForward(4)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="60" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
              </div>
              <div v-show="requestData.ct4.purpose === 'CONSUMPTION'">
                <!-- 用电  -->
                <div class='w6x h1x fL'></div>

                <svg class="w2x h1x posA fMain curP tra-fast" style="left:2em;top:0.5em;" :class="{'active-l':requestData.ct4.direction === 'BACKWARD', 'active-r':requestData.ct4.direction === 'FORWARD'}" @click="changeForward(4)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                <svg class="w4x h4x pr05x ml05x">
                  <use xlink:href="#ico-house"></use>
                </svg>
              </div>
              <div v-show="requestData.ct4.purpose === 'UTILITY'">
                <!-- 电网  -->
                <div class="fL">
                  <div><span class="s-text">{{$t('plant_detail235',['购电'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line>
                  </div>
                  <div><span class="s-text">{{$t('word162',['并网'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                  </div>
                </div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5em;top:-0.5em;" :class="{'active-l':requestData.ct4.direction === 'BACKWARD', 'active-r':requestData.ct4.direction === 'FORWARD'}" @click="changeForward(4)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <svg class="w4x h3x mt05x fL">
                  <use xlink:href="#ico-eTower"></use>
                </svg>
              </div>
              <!-- 电池 -->
              <div v-show="requestData.ct4.purpose === 'BATTERY'">
                <svg class="w4x h3x mt05x fL mr2x">
                  <use xlink:href="#ico-battery3"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:7em;top:-0.5em;" :class="{'active-l':requestData.ct4.direction === 'BACKWARD', 'active-r':requestData.ct4.direction === 'FORWARD'}" @click="changeForward(4)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <div class="fL">
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line><span class="s-text ml05x">{{getLanguageStr('word185','充电')}}</span>
                  </div>
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line><span class="s-text ml05x">{{getLanguageStr('word186','放电')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ct5 -->
          <div class="clearfix mt2x" v-if="spec.ctSpec=='CT6'">
            <div class="w15pct fL h4x line-height">CT5</div>
            <div class="w15pct fL h4x line-height">
              <my-select class="mt1x" v-if="location5Source.length" :list="location5Source" :bindActive="requestData.ct5.purpose" @Click="selectLocation5"></my-select>
            </div>
            <div class="w25pct fL posR">
              <div v-show="requestData.ct5.purpose === 'GENERATION'">
                <!-- 发电  -->
                <svg class="w4x h3x pr05x mr3x">
                  <use xlink:href="#ico-getPower"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5.5em;top:0.5em;" :class="{'active-l':requestData.ct5.direction === 'BACKWARD', 'active-r':requestData.ct5.direction === 'FORWARD'}" @click="changeForward(5)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="60" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
              </div>
              <div v-show="requestData.ct5.purpose === 'CONSUMPTION'">
                <!-- 用电  -->
                <div class='w6x h1x fL'></div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:2em;top:0.5em;" :class="{'active-l':requestData.ct5.direction === 'BACKWARD', 'active-r':requestData.ct5.direction === 'FORWARD'}" @click="changeForward(5)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                <svg class="w4x h4x pr05x ml05x">
                  <use xlink:href="#ico-house"></use>
                </svg>
              </div>
              <div v-show="requestData.ct5.purpose === 'UTILITY'">
                <!-- 电网  -->
                <div class="fL">
                  <div><span class="s-text">{{$t('plant_detail235',['购电'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line>
                  </div>
                  <div><span class="s-text">{{$t('word162',['并网'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                  </div>
                </div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5em;top:-0.5em;" :class="{'active-l':requestData.ct5.direction === 'BACKWARD', 'active-r':requestData.ct5.direction === 'FORWARD'}" @click="changeForward(5)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <svg class="w4x h3x mt05x fL ">
                  <use xlink:href="#ico-eTower"></use>
                </svg>
              </div>
              <!-- 电池 -->
              <div v-show="requestData.ct5.purpose === 'BATTERY'">
                <svg class="w4x h3x mt05x fL mr2x">
                  <use xlink:href="#ico-battery3"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:7em;top:-0.5em;" :class="{'active-l':requestData.ct5.direction === 'BACKWARD', 'active-r':requestData.ct5.direction === 'FORWARD'}" @click="changeForward(5)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <div class="fL">
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line><span class="s-text ml05x">{{getLanguageStr('word185','充电')}}</span>
                  </div>
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line><span class="s-text ml05x">{{getLanguageStr('word186','放电')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ct6 -->
          <div class="clearfix mt2x" v-if="spec.ctSpec=='CT6'">
            <div class="w15pct fL h4x line-height">CT6</div>
            <div class="w15pct fL h4x line-height">
              <my-select class="mt1x" v-if="location6Source.length" :list="location1Source" :bindActive="requestData.ct6.purpose" @Click="selectLocation6"></my-select>
            </div>
            <div class="w25pct fL posR">
              <div v-show="requestData.ct6.purpose === 'GENERATION'">
                <!-- 发电  -->
                <svg class="w4x h3x pr05x mr3x">
                  <use xlink:href="#ico-getPower"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5.5em;top:0.5em;" :class="{'active-l':requestData.ct6.direction === 'BACKWARD', 'active-r':requestData.ct6.direction === 'FORWARD'}" @click="changeForward(6)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="60" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
              </div>
              <div v-show="requestData.ct6.purpose === 'CONSUMPTION'">
                <!-- 用电  -->
                <div class='w6x h1x fL'></div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:2em;top:0.5em;" :class="{'active-l':requestData.ct6.direction === 'BACKWARD', 'active-r':requestData.ct6.direction === 'FORWARD'}" @click="changeForward(6)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                <svg class="w4x h4x pr05x ml05x ">
                  <use xlink:href="#ico-house"></use>
                </svg>
              </div>
              <div v-show="requestData.ct6.purpose === 'UTILITY'">
                <!-- 电网  -->
                <div class="fL">
                  <div><span class="s-text">{{$t('plant_detail235',['购电'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line>
                  </div>
                  <div><span class="s-text">{{$t('word162',['并网'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                  </div>
                </div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5em;top:-0.5em;" :class="{'active-l':requestData.ct6.direction === 'BACKWARD', 'active-r':requestData.ct6.direction === 'FORWARD'}" @click="changeForward(6)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <svg class="w4x h3x mt05x fL ">
                  <use xlink:href="#ico-eTower"></use>
                </svg>
              </div>
              <!-- 电池 -->
              <div v-show="requestData.ct6.purpose === 'BATTERY'">
                <svg class="w4x h3x mt05x fL mr2x">
                  <use xlink:href="#ico-battery3"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:7em;top:-0.5em;" :class="{'active-l':requestData.ct6.direction === 'BACKWARD', 'active-r':requestData.ct6.direction === 'FORWARD'}" @click="changeForward(6)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <div class="fL">
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line><span class="s-text ml05x">{{getLanguageStr('word185','充电')}}</span>
                  </div>
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line><span class="s-text ml05x">{{getLanguageStr('word186','放电')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 三项系统 -->
        <div v-if="type=='THREE_PHASE'">
          <div class="clearfix mt2x">
            <div class="w15pct fL">{{$t('word1374',['互感器'])}}</div>
            <div class="w15pct fL">{{getLanguageStr('word1972','安装位置')}}</div>
            <div class="w25pct fL">{{getLanguageStr('phrase851','互感器安装方向（点击箭头可切换）')}}</div>
            <div class="fL">{{$t('word1376',['电流比'])}} (A/A)</div>
          </div>
          <div class="clearfix mt2x" v-if="spec.ctSpec=='CT3'||spec.ctSpec=='CT6'">
            <div class="w15pct fL h4x line-height">CT1+CT2+CT3</div>
            <div class="w15pct fL h4x line-height">
              <my-select class="mt1x" v-if="location1Source.length" :list="location1Source" :bindActive="requestData.ct1.purpose" @Click="selectLocation1"></my-select>
            </div>
            <div class="w25pct fL posR">
              <div v-show="requestData.ct1.purpose === 'GENERATION'">
                <!-- 发电  -->
                <svg class="w4x h3x pr05x mr3x">
                  <use xlink:href="#ico-getPower"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5.5em;top:0.5em;" :class="{'active-l':requestData.ct1.direction === 'BACKWARD', 'active-r':requestData.ct1.direction === 'FORWARD'}" @click="changeForward(1)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="60" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
              </div>
              <div v-show="requestData.ct1.purpose === 'CONSUMPTION'">
                <!-- 用电  -->
                <div class='w6x h1x fL'></div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:2em;top:0.5em;" :class="{'active-l':requestData.ct1.direction === 'BACKWARD', 'active-r':requestData.ct1.direction === 'FORWARD'}" @click="changeForward(1)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                <svg class="w4x h4x pr05x ml05x ">
                  <use xlink:href="#ico-house"></use>
                </svg>
              </div>
              <div v-show="requestData.ct1.purpose === 'UTILITY'">
                <!-- 电网  -->
                <div class="fL">
                  <div><span class="s-text">{{$t('plant_detail235',['购电'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line>
                  </div>
                  <div><span class="s-text">{{$t('word162',['并网'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                  </div>
                </div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5em;top:-0.5em;" :class="{'active-l':requestData.ct1.direction === 'BACKWARD', 'active-r':requestData.ct1.direction === 'FORWARD'}" @click="changeForward(1)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <svg class="w4x h3x mt05x fL">
                  <use xlink:href="#ico-eTower"></use>
                </svg>
              </div>
              <!-- 电池 -->
              <div v-show="requestData.ct1.purpose === 'BATTERY'">
                <svg class="w4x h3x mt05x fL mr2x">
                  <use xlink:href="#ico-battery3"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:7em;top:-0.5em;" :class="{'active-l':requestData.ct1.direction === 'BACKWARD', 'active-r':requestData.ct1.direction === 'FORWARD'}" @click="changeForward(1)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <div class="fL">
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line><span class="s-text ml05x">{{getLanguageStr('word185','充电')}}</span>
                  </div>
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line><span class="s-text ml05x">{{getLanguageStr('word186','放电')}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="requestData.ct1.purpose && requestData.ct1.purpose!=-1">
              <input-text class="current mt05x" :max-length="8" verifyMethod='' v-model="requestData.currentRatioIn" :only="'absNumber'" :matchType="'floor2x'" :errorTip="errMsg.currentRatioIn.msg" :isError="{error:errMsg.currentRatioIn.show}" @Blur="currentBlur(1)"></input-text>&nbsp;/
              <input-text class="current mt05x" :max-length="8" verifyMethod='' v-model="requestData.currentRatioOut" :only="'absNumber'" :matchType="'floor2x'" :errorTip="errMsg.currentRatioOut.msg" :isError="{error:errMsg.currentRatioOut.show}" @Blur="currentBlur(1)"></input-text>&nbsp;=
              <span>{{requestData.currentRatio}}</span>
            </div>
          </div>
          <div class="clearfix mt2x" v-if="spec.ctSpec=='CT6'">
            <div class="w15pct fL h4x line-height">CT4+CT5+CT6</div>
            <div class="w15pct fL h4x line-height">
              <my-select class="mt1x" v-if="location1Source.length" :list="location1Source" :bindActive="requestData.ct2.purpose" @Click="selectLocation2"></my-select>
            </div>
            <div class="w25pct fL posR">
              <div v-show="requestData.ct2.purpose === 'GENERATION'">
                <!-- 发电  -->
                <svg class="w4x h3x pr05x mr3x">
                  <use xlink:href="#ico-getPower"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5.5em;top:0.5em;" :class="{'active-l':requestData.ct2.direction === 'BACKWARD', 'active-r':requestData.ct2.direction === 'FORWARD'}" @click="changeForward(2)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="60" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
              </div>
              <div v-show="requestData.ct2.purpose === 'CONSUMPTION'">
                <!-- 用电  -->
                <div class='w6x h1x fL'></div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:2em;top:0.5em;" :class="{'active-l':requestData.ct2.direction === 'BACKWARD', 'active-r':requestData.ct2.direction === 'FORWARD'}" @click="changeForward(2)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <dash-line class="LDash" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                <svg class="w4x h4x pr05x ml05x ">
                  <use xlink:href="#ico-house"></use>
                </svg>
              </div>
              <div v-show="requestData.ct2.purpose === 'UTILITY'">
                <!-- 电网  -->
                <div class="fL">
                  <div><span class="s-text">{{$t('plant_detail235',['购电'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line>
                  </div>
                  <div><span class="s-text">{{$t('word162',['并网'])}}</span>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line>
                  </div>
                </div>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:5em;top:-0.5em;" :class="{'active-l':requestData.ct2.direction === 'BACKWARD', 'active-r':requestData.ct2.direction === 'FORWARD'}" @click="changeForward(2)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <svg class="w4x h3x mt05x fL ">
                  <use xlink:href="#ico-eTower"></use>
                </svg>
              </div>
              <!-- 电池 -->
              <div v-show="requestData.ct2.purpose === 'BATTERY'">
                <svg class="w4x h3x mt05x fL mr2x">
                  <use xlink:href="#ico-battery3"></use>
                </svg>
                <svg class="w2x h1x posA fMain curP tra-fast" style="left:7em;top:-0.5em;" :class="{'active-l':requestData.ct2.direction === 'BACKWARD', 'active-r':requestData.ct2.direction === 'FORWARD'}" @click="changeForward(2)">
                  <use xlink:href="#ico-flowArrow"></use>
                </svg>
                <div class="fL">
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false" :directionLine="'RL'"></dash-line><span class="s-text ml05x">{{getLanguageStr('word185','充电')}}</span>
                  </div>
                  <div>
                    <dash-line class="LDash1" :dashLine="false" :viewWidth="70" :viewHeight="10" :isAnimation="true" :isColor="false"></dash-line><span class="s-text ml05x">{{getLanguageStr('word186','放电')}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="requestData.ct1.purpose && requestData.ct1.purpose!=-1">
              <input-text class="current mt05x" :max-length="8" verifyMethod='' v-model="requestData.currentRatioIn2" :only="'absNumber'" :matchType="'floor2x'" :errorTip="errMsg.currentRatioIn.msg" :isError="{error:errMsg.currentRatioIn.show}" @Blur="currentBlur(2)"></input-text>&nbsp;/
              <input-text class="current mt05x" :max-length="8" verifyMethod='' v-model="requestData.currentRatioOut2" :only="'absNumber'" :matchType="'floor2x'" :errorTip="errMsg.currentRatioOut.msg" :isError="{error:errMsg.currentRatioOut.show}" @Blur="currentBlur(2)"></input-text>&nbsp;=
              <span>{{requestData.currentRatio2}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </window>
</template> 
<script>
import { mapGetters } from 'vuex'
import Loading from '@/components/common/ui/Loading'
import InputText from '@/components/common/ui/InputText'
import MySelect from '@/components/common/ui/Select'
import Window from '@/components/common/ui/WindowForNew'
import DashLine from '@/components/common/ui/DashLine'
import * as lib from "@/util/lib"
import { getLanguageStr } from '@/util/language'
import * as configApi from '@/api/maintain/config'

// 电流比有效的正数
let validReg = /^([1-9]\d*)(\.\d+)?$/

export default {
  name: 'MeterSetup',
  // props:{
  // 	meterInfo: {
  // 		type: Object,
  // 		default: () =>({})
  // 	}
  // },
  components: {
    Loading,
    InputText,
    MySelect,
    Window,
    DashLine
  },
  data () {
    return {
      title: getLanguageStr('word1769', '电表配置'),
      meter: {},
      spec: {},
      stationId: '',
      type: 'SINGLE_PHASE',  //用户默认是指单相
      typesRadio: 'SINGLE_PHASE',
      requestData: {
        ct1: {
          direction: 'FORWARD',
          purpose: 'GENERATION'
        },
        ct2: {
          direction: 'BACKWARD',
          purpose: 'UTILITY'
        },
        ct3: {
          direction: 'BACKWARD',
          purpose: 'CONSUMPTION'
        },
        ct4: {
          direction: null,
          purpose: null
        },
        ct5: {
          direction: null,
          purpose: null
        },
        ct6: {
          direction: null,
          purpose: null
        },
        currentRatioIn: 1,
        currentRatioIn2: 1,
        currentRatioOut: 1,
        currentRatioOut2: 1,
        currentRatio: 1,
        currentRatio2: 1
      },
      location1Source: [
        { text: getLanguageStr('word559', '发电'), value: 'GENERATION' },
        { text: getLanguageStr('word560', '电网'), value: 'UTILITY' },
        { text: getLanguageStr('word561', '用电'), value: 'CONSUMPTION' },
        { text: getLanguageStr('word37', '电池'), value: 'BATTERY' },
        { text: getLanguageStr('word116', '无'), value: null }
      ],
      location2Source: [
        { text: getLanguageStr('word559', '发电'), value: 'GENERATION' },
        { text: getLanguageStr('word560', '电网'), value: 'UTILITY' },
        { text: getLanguageStr('word561', '用电'), value: 'CONSUMPTION' },
        { text: getLanguageStr('word37', '电池'), value: 'BATTERY' },
        { text: getLanguageStr('word116', '无'), value: null }
      ],
      location3Source: [
        { text: getLanguageStr('word559', '发电'), value: 'GENERATION' },
        { text: getLanguageStr('word560', '电网'), value: 'UTILITY' },
        { text: getLanguageStr('word561', '用电'), value: 'CONSUMPTION' },
        { text: getLanguageStr('word37', '电池'), value: 'BATTERY' },
        { text: getLanguageStr('word116', '无'), value: null }
      ],
      location4Source: [
        { text: getLanguageStr('word559', '发电'), value: 'GENERATION' },
        { text: getLanguageStr('word560', '电网'), value: 'UTILITY' },
        { text: getLanguageStr('word561', '用电'), value: 'CONSUMPTION' },
        { text: getLanguageStr('word37', '电池'), value: 'BATTERY' },
        { text: getLanguageStr('word116', '无'), value: null }
      ],
      location5Source: [
        { text: getLanguageStr('word559', '发电'), value: 'GENERATION' },
        { text: getLanguageStr('word560', '电网'), value: 'UTILITY' },
        { text: getLanguageStr('word561', '用电'), value: 'CONSUMPTION' },
        { text: getLanguageStr('word37', '电池'), value: 'BATTERY' },
        { text: getLanguageStr('word116', '无'), value: null }
      ],
      location6Source: [
        { text: getLanguageStr('word559', '发电'), value: 'GENERATION' },
        { text: getLanguageStr('word560', '电网'), value: 'UTILITY' },
        { text: getLanguageStr('word561', '用电'), value: 'CONSUMPTION' },
        { text: getLanguageStr('word37', '电池'), value: 'BATTERY' },
        { text: getLanguageStr('word116', '无'), value: null }
      ],
      errMsg: {
        currentRatioIn: {
          msg: '',
          show: false,
          msgs: [getLanguageStr('plant326', '请输入电源电流'), getLanguageStr('plant327', '请输入正数')]
        },
        currentRatioOut: {
          msg: '',
          show: false,
          msgs: [getLanguageStr('plant328', '请输入监测电流'), getLanguageStr('plant327', '请输入正数')]
        }
      }
    }
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    resetRequsetData () {
      // this.requestData.ct1.purpose='GENERATION'
      // this.requestData.ct1.direction='FORWARD'
      // this.requestData.ct2.purpose='UTILITY'
      // this.requestData.ct2.direction='FORWARD'
      // this.requestData.ct3.purpose='CONSUMPTION'
      // this.requestData.ct3.direction='FORWARD'

      // this.requestData.ct4.purpose=null
      // this.requestData.ct4.direction=null
      // this.requestData.ct5.purpose=null
      // this.requestData.ct5.direction=null
      // this.requestData.ct6.purpose=null
      // this.requestData.ct6.direction=null
      
      this.setPirpose(true)
      this.requestData.currentRatioIn = 1
      this.requestData.currentRatioOut = 1
      this.requestData.currentRatio = 1
      this.requestData.currentRatioIn1 = 1
      this.requestData.currentRatioOut1 = 1
      this.requestData.currentRatio1 = 1

    },
    open (data, id) {  //(列表信息，电站id)
      this.$refs.windowMeter.show()
      this.resetRequsetData()
      for (let key in this.errMsg) {
        for (let attr in this.errMsg[key]) {
          if (attr === 'show') {
            this.errMsg[key][attr] = false
          }
        }
      }
      this.meter = data
      this.stationId = id
      this._getMeterPro().then(res => { //pass平台获取选项

        let purpose = res.purpose
        // for(let i = 1; i<7;i++){
        // 	let locationSource = `location${i}Source`
        // 	this[locationSource] = this[locationSource].filter(item=>{
        // 		if(purpose.includes(item.value)){
        // 			return item
        // 		}else if (!item.value){
        // 			return item
        // 		}
        // 	})

        // }
        // 此处都是设置默认显示
        this.spec = res
        // this.spec.threePurpose='CONSUMPTION'
        if (res) {
          if (this.spec.ctSpec == 'CT1') {
            this.typesRadio = 'SINGLE_PHASE'
          } else {
            if (res.meterType.includes('THREE_PHASE')) {
              this.requestData.ct3 = {
                direction: null,
                purpose: null
              }
              this.typesRadio = 'THREE_PHASE'
            } else {
              this.typesRadio = 'SINGLE_PHASE'
              this.requestData.ct3 = {
                direction: 'BACKWARD',
                purpose: 'CONSUMPTION'
              }
            }
            this.typesRadio = res.meterType
          }
          
          
        }
        this.setPirpose(true)
      }).then(res => {

        this.resetData()
      })
      // this.type = ( this.meter.config && this.meter.config.type ) || this.typesRadio
    },
    // 设置下拉选中的状态
    setPirpose (setDefault) {  
      if (!this.spec.singlePurpose) return
      if (setDefault) {
        if (this.spec.defaultType == "THREE_PHASE") {
         
          if (this.spec.ctSpec == 'CT6') {
           
            this.requestData['ct1'].purpose = this.spec.threePurpose.split(',')[0]
            this.requestData['ct1'].direction = 'FORWARD'
            this.requestData['ct2'].purpose = this.spec.threePurpose.split(',')[1]
            this.requestData['ct2'].direction = 'FORWARD'
            
          } else {
           
            // 原先此处只有ct1
            // this.requestData['ct1'].purpose = this.spec.threePurpose.split(',')[0]
            // this.requestData['ct1'].direction = 'FORWARD'
            

            this.requestData['ct1'].purpose = 'GENERATION'
            this.requestData['ct1'].direction = 'FORWARD'
            this.requestData['ct2'].purpose = 'UTILITY'
            this.requestData['ct2'].direction = 'FORWARD'
            this.requestData['ct3'].purpose = 'CONSUMPTION'
            this.requestData['ct3'].direction = 'FORWARD'
          }

        } else {
          
          let sp = this.spec.singlePurpose.split(',')
          for (let i = 1; i < sp.length + 1; i++) {
            let ct = `ct${i}`
            this.requestData[ct].purpose = sp[i - 1]
            this.requestData[ct].direction = 'FORWARD'
          }
        }
        // this.requestData.ct1.purpose = this.spec.threePurpose
      }

    },
    resetData () {
      if (!this.meter.config) {
        this.type = this.typesRadio instanceof Array ? this.typesRadio[0] : this.typesRadio
        this.type = this.spec.defaultType
        this.resetRequsetData()
      } else {
        this.type = this.meter.config.type
        if (this.type == 'SINGLE_PHASE') {  //单相
          if (this.spec.ctSpec == 'CT1') {
            this.echoLocation(1)
            this.echoForward(1)
          } else if (this.spec.ctSpec == 'CT3') {
            this.echoLocation(1)
            this.echoLocation(2)
            this.echoLocation(3)

            this.echoForward(1)
            this.echoForward(2)
            this.echoForward(3)
          } else {

            this.echoLocation(1)
            this.echoLocation(2)
            this.echoLocation(3)
            this.echoLocation(4)
            this.echoLocation(5)
            this.echoLocation(6)

            this.echoForward(1)
            this.echoForward(2)
            this.echoForward(3)
            this.echoForward(4)
            this.echoForward(5)
            this.echoForward(6)
          }
        } else {
          this.requestData.currentRatioIn = this.meter.config.currentRatioIn
          this.requestData.currentRatioOut = this.meter.config.currentRatioOut
          this.requestData.currentRatio = parseFloat(this.meter.config.currentRatioIn / this.meter.config.currentRatioOut).toFixed(2)
          if (this.spec.ctSpec == 'CT3') {
            this.echoLocation(1)
            this.echoForward(1)
          } else {
            this.echoLocation(1)
            this.echoLocation(2)

            this.echoForward(1)
            this.echoForward(2)

            this.requestData.currentRatioIn1 = this.meter.config.currentRatioIn1
            this.requestData.currentRatioOut1 = this.meter.config.currentRatioOut1
            this.requestData.currentRatio1 = parseFloat(this.meter.config.currentRatioIn1 / this.meter.config.currentRatioOut1).toFixed(2)
          }
        }
      }

    },
    _getMeterPro () {
      return new Promise((resolve, reject) => {
        configApi.GetMeterPro(this.stationId, this.meter.id).then(res => {
          resolve(res)
        }, error => {
          reject(error)
        })
      })

    },
    getSingle () {
      /*
      ct1 发电  沿着发电
      ct2 电网  沿着并网
      ct3 用电  沿着用电
       */
      this.requestData.ct3 = {
        direction: 'BACKWARD',
        purpose: 'CONSUMPTION'
      }
    
      if (!this.meter.config) { //未配置

        this.resetRequsetData()
      } else {
        if (this.meter.config.type == 'THREE_PHASE') { //如果配置是三相，切换为单相时取默认值
          this.resetRequsetData()
        } else {  //如果配置过是单相取配置值
          if (this.spec.ctSpec == 'CT1') {
            this.echoLocation(1)
            this.echoForward(1)
          } else if (this.spec.ctSpec == 'CT3') {
            this.echoLocation(1)
            this.echoLocation(2)
            this.echoLocation(3)

            this.echoForward(1)
            this.echoForward(2)
            this.echoForward(3)
          } else {

            this.echoLocation(1)
            this.echoLocation(2)
            this.echoLocation(3)
            this.echoLocation(4)
            this.echoLocation(5)
            this.echoLocation(6)

            this.echoForward(1)
            this.echoForward(2)
            this.echoForward(3)
            this.echoForward(4)
            this.echoForward(5)
            this.echoForward(6)
          }
        }
      }
    },
    getThree () {
      this.requestData.ct3 = {
        direction: null,
        purpose: null
      }
      if (!this.meter.config) {
        this.resetRequsetData()
      } else {
        if (this.meter.config.type == 'THREE_PHASE') { //如果配置过取配置值，
          this.requestData.currentRatioIn = this.meter.config.currentRatioIn
          this.requestData.currentRatioOut = this.meter.config.currentRatioOut
          this.requestData.currentRatio = parseFloat(this.meter.config.currentRatioIn / this.meter.config.currentRatioOut).toFixed(2)
          if (this.spec.ctSpec == 'CT3') {
            this.echoLocation(1)
            this.echoForward(1)
          } else {
            this.echoLocation(1)
            this.echoLocation(2)

            this.echoForward(1)
            this.echoForward(2)

            this.requestData.currentRatioIn1 = this.meter.config.currentRatioIn1
            this.requestData.currentRatioOut1 = this.meter.config.currentRatioOut1
            this.requestData.currentRatio1 = parseFloat(this.meter.config.currentRatioIn1 / this.meter.config.currentRatioOut1).toFixed(2)
          }
        } else {
          this.resetRequsetData()
          this.requestData[`ct1`].purpose = this.spec.threePurpose.split(',')[0]
        }
      }



    },
    close () {
      this.$refs.windowMeter.hide()
    },
    echoLocation (index) {
      let { config } = this.meter
      if (!config) return
      if (config[`ct${index}`]) {
        let { purpose } = config[`ct${index}`]
        // let {value} = this.purposes.find(item => item.purpose === purpose)
        this.requestData[`ct${index}`].purpose = purpose
        // for(let key in this.echo[`location${index}Source`] ) {
        // 	this.$set(this.echo[`location${index}Source`], key, false)
        // }
        // this.$set(this.echo[`location${index}Source`], value, true)
      } else {
        //配置为null
        if (this.type === 'SINGLE_PHASE') {
          this.requestData[`ct${index}`].purpose = this.spec.singlePurpose ? (this.spec.singlePurpose.split(',')[index - 1]?this.spec.singlePurpose.split(',')[index - 1]:null) : config[`ct${index}`]
         
        } else {
          this.requestData[`ct${index}`].purpose = this.spec.threePurpose.split(',')[index - 1]?this.spec.threePurpose.split(',')[index - 1]:null
        }
        // this.$set(this.echo[`location${index}Source`], 5, true)
      }

    },
    echoForward (index) {
      let { config } = this.meter
      if (!config) return
      if (config[`ct${index}`]) {
        let { direction } = config[`ct${index}`]
        if (direction === 'BACKWARD') {
          this.$set(this.requestData[`ct${index}`], `direction`, 'BACKWARD')
        } else {
          this.$set(this.requestData[`ct${index}`], `direction`, 'FORWARD')
        }
      } else {
        // 配置为null
        this.$set(this.requestData[`ct${index}`], `direction`, null)
      }

    },
    changeForward (index) {
      if (this.requestData[`ct${index}`].direction === 'FORWARD') {
        this.$set(this.requestData[`ct${index}`], 'direction', 'BACKWARD')
      } else {
        this.$set(this.requestData[`ct${index}`], 'direction', 'FORWARD')
      }
    },
    selectLocation1 (index) {
      this.requestData.ct1.purpose = this.location1Source[index].value
    },
    selectLocation2 (index) {
      this.requestData.ct2.purpose = this.location2Source[index].value
    },
    selectLocation3 (index) {
      this.requestData.ct3.purpose = this.location3Source[index].value
    },
    selectLocation4 (index) {
      this.requestData.ct4.purpose = this.location4Source[index].value
    },
    selectLocation5 (index) {
      this.requestData.ct5.purpose = this.location5Source[index].value
    },
    selectLocation6 (index) {
      this.requestData.ct6.purpose = this.location6Source[index].value
    },
    currentBlur (type) {
      if (type == 1) {
        let { currentRatioIn, currentRatioOut } = this.requestData
        if (currentRatioOut > 0) {
          this.requestData.currentRatio = parseFloat(currentRatioIn / currentRatioOut).toFixed(2)
        } else {
          this.requestData.currentRatio = ''
        }
      } else {
        let { currentRatioIn2, currentRatioOut2 } = this.requestData
        if (currentRatioOut2 > 0) {
          this.requestData.currentRatio2 = parseFloat(currentRatioIn2 / currentRatioOut2).toFixed(2)
        } else {
          this.requestData.currentRatio2 = ''
        }
      }

    },
    judgeCurrent (value, param) {
      if (parseFloat(value) >= 0) {
        if (!validReg.test(value)) {
          this.errMsg[param].show = true
          this.errMsg[param].msg = this.errMsg[param].msgs[1]
          return false
        } else {
          this.errMsg[param].show = false
          this.errMsg[param].msg = ''
          return true
        }
      } else {
        this.errMsg[param].show = true
        this.errMsg[param].msg = this.errMsg[param].msgs[0]
        return false
      }
    },
    save () {
      let req = {}
      let { ct1, ct2, ct3, ct4, ct5, ct6, currentRatioIn, currentRatioOut, currentRatioIn1, currentRatioOut1, currentRatioIn2, currentRatioOut2 } = this.requestData
      let locations = []
      let l1 = ct1.purpose !== null && ct1.purpose !== -1 ? [ct1.purpose] : []
      let l2 = ct2.purpose !== null && ct2.purpose !== -1 ? [ct2.purpose] : []
      let l3 = ct3.purpose !== null && ct3.purpose !== -1 ? [ct3.purpose] : []
      let l4 = ct4.purpose !== null && ct4.purpose !== -1 ? [ct4.purpose] : []
      let l5 = ct5.purpose !== null && ct5.purpose !== -1 ? [ct5.purpose] : []
      let l6 = ct6.purpose !== null && ct6.purpose !== -1 ? [ct6.purpose] : []
      locations = _.compact([...l1, ...l2, ...l3, ...l4, ...l5, ...l6])
      if (this.type === 'SINGLE_PHASE') {
        // 单相电表
        if (this.spec.ctSpec == 'CT1') {
          if (ct1.purpose === '') {
            this.$notify(getLanguageStr('phrase609', '安装位置不能全部选无') + ', ' + getLanguageStr('phrase611', '请重新选择'))
            return
          }
          req = {
            type: this.type,
            ct1,
          }
        } else if (this.spec.ctSpec == 'CT3') {
          if (ct1.purpose === '' && ct2.purpose == '' && ct3.purpose == '') {
            this.$notify(getLanguageStr('phrase609', '安装位置不能全部选无') + ', ' + getLanguageStr('phrase611', '请重新选择'))
            return
          }

          if (new Set(locations).size < locations.length) {
            this.$notify(getLanguageStr('phrase610', '安装位置存在重复') + ', ' + getLanguageStr('phrase611', '请重新选择'))
            return
          }
          req = {
            type: this.type,
            ct1,
            ct2,
            ct3,
          }
        } else {
          if (ct1.purpose === '' && ct2.purpose == '' && ct3.purpose == '' && ct4.purpose == '' && ct5.purpose == '' && ct6.purpose == '') {
            this.$notify(getLanguageStr('phrase609', '安装位置不能全部选无') + ', ' + getLanguageStr('phrase611', '请重新选择'))
            return
          }
          if (new Set(locations).size < locations.length) {
            this.$notify(getLanguageStr('phrase610', '安装位置存在重复') + ', ' + getLanguageStr('phrase611', '请重新选择'))
            return
          }
          req = {
            type: this.type,
            ct1,
            ct2,
            ct3,
            ct4,
            ct5,
            ct6,
          }
        }
        configApi.meterConfig(this.stationId, this.meter.id, req).then(() => {
          this.close()
          this.$emit('meterSetSuccess')
        }).catch(error => {
          !_.isEmpty(error) && this.$notify(error)
        })
      } else {
        // 三相电表 
        if (this.spec.ctSpec == 'CT3') {
          if (ct1.purpose === '') {
            this.$notify(getLanguageStr('phrase609', '安装位置不能全部选无') + ', ' + getLanguageStr('phrase611', '请重新选择'))
            return
          }
          req = {
            // deviceId:this.meter.id,
            // stationId:this.stationId,
            type: this.type,
            ct1,
            currentRatioIn,
            currentRatioOut
          }
        } else {
          if (ct1.purpose === '' && ct2.purpose === '') {
            this.$notify(getLanguageStr('phrase609', '安装位置不能全部选无') + ', ' + getLanguageStr('phrase611', '请重新选择'))
            return
          }
          if (new Set(locations).size < locations.length) {
            this.$notify(getLanguageStr('phrase610', '安装位置存在重复') + ', ' + getLanguageStr('phrase611', '请重新选择'))
            return
          }
          req = {
            // deviceId:this.meter.id,
            // stationId:this.stationId,
            type: this.type,
            ct1,
            ct2,
            currentRatioIn,
            currentRatioOut,
            currentRatioIn2,
            currentRatioOut2
          }
        }
        configApi.meterConfig(this.stationId, this.meter.id, req).then(() => {
          this.close()
          this.$emit('meterSetSuccess')
        }).catch(error => {
          !_.isEmpty(error) && this.$notify(error)
        })
      }
    }
  },
  computed: {
    // ...mapGetters({
    // 	stationId: 'stationDetail/stationId'
    // })
  },
  mounted () {
    lib.setScroll($("#meterSetup [fillHeight][scroll]"))
  }
}
</script>
<style lang="scss" scoped>
table tr > *,
.table tr > * {
  padding-bottom: 1.5em;
}
.LDash {
  vertical-align: top;
  display: inline-block;
  margin-top: 1.5em;
}
.LDash1 {
  vertical-align: top;
  display: inline-block;
  margin-top: 0.5em;
  margin-left: 0.5em;
}
.line-height {
  line-height: 4em;
}
.s-text {
  display: inline-block;
  line-height: 2em;
  height: 2em;
  width: 6em;
}
.bg-meter {
  font-size: 1.1em;
  width: 10em;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.4em;
  margin-bottom: 1em;
  li {
    width: 33.3%;
    margin-bottom: 0.5em;
    float: left;
  }
}
.current {
  width: 10em;
  display: inline-block;
}
.active-l {
  transform: perspective(2em) rotateY(180deg);
}
.active-r {
  transform: perspective(2em) rotateY(0deg);
}
.fMain.curP.tra-fast {
  right: 8em !important;
  left: auto !important;
}
.w25pct {
  width: 227px;
}
.active-l,.active-r{
  left:7em!important
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/MeterSetup.vue